import { Box, Button } from "@mui/material";
import { defineMessages } from "react-intl";
import { Msg, MsgProvider } from "./Msg";
import { P } from "./Typography";

const messages = defineMessages({
  "score.min": {
    id: "score.min",
    defaultMessage: "Not me at all",
  },
  "score.max": {
    id: "score.max",
    defaultMessage: "Totally me",
  },
});

const DEFAULT_OPTIONS = Array(10)
  .fill()
  .map((_, i) => ({ value: i + 1, label: i + 1 }));

const ScoreInner = ({
  value,
  onChange,
  error,
  options = DEFAULT_OPTIONS,
  left = (
    <P>
      <Msg id="score.min" />
    </P>
  ),
  right = (
    <P>
      <Msg id="score.max" />
    </P>
  ),
  sx = {},
}) => {
  const onlySmPlus = (el) => (
    <Box
      sx={{
        display: { xs: "none", sm: "block" },
      }}
    >
      {el}
    </Box>
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        overflowX: "auto",
        ...sx,
      }}
    >
      {onlySmPlus(left)}
      <Box
        sx={{
          mx: { xs: 0, sm: 1.5 },
          display: "flex",
          flexFlow: "row",
          flex: "1 1 auto",
          justifyContent: "space-around",
          maxWidth: 600,
        }}
      >
        {options.map((option) => (
          <Button
            key={option.value}
            variant={value === option.value ? "contained" : "outlined"}
            onClick={() => onChange({ value: option.value })}
            color={error ? "error" : "primary"}
            sx={{
              flex: "1 1 auto",
              minWidth: 0,
              maxWidth: 44,
              mx: 0.5,
              p: "5px",
            }}
          >
            {option.label}
          </Button>
        ))}
      </Box>
      {onlySmPlus(right)}
    </Box>
  );
};

export const Score = (props) => (
  <MsgProvider messages={messages}>
    <ScoreInner {...props} />
  </MsgProvider>
);
